export enum Loaders {
  fetchingUser = "FetchingUser",
  globalLoader = "GlobalLoader",
}
